function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M6.225135 2.84625C5.63943 2.26035 5.63943 1.31085 6.225135 0.7251C6.8109 0.13935 7.76046 0.13935 8.346225 0.7251L18.0054 10.384275C18.89745 11.27676 18.89745 12.72321 18.0054 13.615725L8.346225 23.274903C7.76043 23.8606242 6.8109 23.86066365 6.225135 23.274903C5.63937 22.689138 5.639415 21.739605 6.225135 21.15381L15.3789 12L6.225135 2.84625Z"
});

var SvgCaretRightBold = function SvgCaretRightBold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCaretRightBold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/caret-right-bold.ea265ff3.svg";
export { ForwardRef as ReactComponent };